import { FC, ReactNode } from 'react';
import { errorClass, labelClass } from 'shared/theme/colorTokens';

interface FormFieldProps {
  label?: ReactNode;
  /** Mensaje de error; si es falsy no se muestra nada. */
  error?: ReactNode;
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Contenedor estándar de un campo de formulario: label arriba, control
 * (`children`) y mensaje de error abajo. Sirve para cualquier control
 * (input, autocomplete, datepicker, teléfono...).
 */
const FormField: FC<FormFieldProps> = ({
  label,
  error,
  htmlFor,
  className,
  children
}) => (
  <div className={className}>
    {label && (
      <label htmlFor={htmlFor} className={labelClass}>
        {label}
      </label>
    )}
    {children}
    {error && <p className={errorClass}>{error}</p>}
  </div>
);

export default FormField;
